import * as React from "react";
import styled from "styled-components";
import { NavigationButton } from "./NavigationButton";
import { ImageSliderProps } from "./types";

const sliderData = {
  currentImage: "https://cdn.builder.io/api/v1/image/assets/TEMP/e741a286c00bd6bbd433d97de93c8d73f39ae4281f5b2e10023f61d8bc995ae7?placeholderIfAbsent=true&apiKey=3ff581d1ced34e86ad9fe32423196fa7",
  navigationImages: [
    { src: "https://cdn.builder.io/api/v1/image/assets/TEMP/d3e6bfe73fe3f1d017b99ec58315db6cd00ab4e3b5f7df917dd1132ea905c3fc?placeholderIfAbsent=true&apiKey=3ff581d1ced34e86ad9fe32423196fa7", alt: "Navigation image 1" },
    { src: "https://cdn.builder.io/api/v1/image/assets/TEMP/3bc0a10e2acdcb75fcffad83ed20ad912db0bf94edd83eeb28ceb61128c2fc71?placeholderIfAbsent=true&apiKey=3ff581d1ced34e86ad9fe32423196fa7", alt: "Navigation image 2" },
    { src: "https://cdn.builder.io/api/v1/image/assets/TEMP/2bee579c11036b81e64c2ef94d26257c7e964f0a1b0d64864ed74f8a2e57a967?placeholderIfAbsent=true&apiKey=3ff581d1ced34e86ad9fe32423196fa7", alt: "Navigation image 3" }
  ]
};

export const Player = () => {
  return (
    <SliderContainer>
      <ImageContainer>
          <MainImageWrapper>
            <MainImage
              loading="lazy"
              src={sliderData.currentImage}
              alt="Main slider image"
            />
            <CurrentIndicator />
          </MainImageWrapper>
        </ImageContainer>
      
      
    </SliderContainer>
  );
};

const SliderContainer = styled.div`
  border-radius: 0;
  display: flex;
  max-width: 50%;
  flex-direction: column;
  min-width: 668px;
  height: 375px;
`;

const SliderWrapper = styled.div`
  border-radius: 8px;
  background-color: #f3f3f3;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  /*padding: 1px 0 12px;*/
  font-family: "Roboto","Montserrat";
  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

const ImageContainer = styled.div`
  border-radius: 8px 8px 8px 8px;
  background-color: #bdbdbd;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 150px 80px 0;
  height: 375px;
  @media (max-width: 991px) {
    max-width: 100%;
    padding: 100px 20px 0;
  }
`;

const MainImageWrapper = styled.div`
  z-index: 10;
  display: flex;
  margin-bottom: -5px;
  width: 83px;
  flex-direction: column;
`;

const MainImage = styled.img`
  aspect-ratio: 1.01;
  object-fit: contain;
  object-position: center;
  width: 100%;
`;

const CurrentIndicator = styled.div`
  // background-color: #fff;
  border-radius: 50%;
  align-self: center;
  display: flex;
  margin-top: 173px;
  width: 11px;
  height: 11px;
  // border: 3px solid #1589fb;
  @media (max-width: 991px) {
    margin-top: 40px;
  }
`;

const NavigationContainer = styled.div`
  align-self: center;
  display: flex;
  margin-top: 18px;
  width: 223px;
  max-width: 100%;
  align-items: center;
  gap: 10px;
  color: #1589fb;
  white-space: nowrap;
  font: 400 14px Roboto, sans-serif;
  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const NavigationText = styled.button`
  text-align: right;
  align-self: stretch;
  margin: auto 0;
  background: none;
  border: none;
  color: inherit;
  font: inherit;
  cursor: pointer;
  padding: 0;
  
  &:focus {
    outline: 2px solid #1589fb;
    border-radius: 4px;
  }
`;

const TextInput = styled.div`
  position: absolute;
  height: auto;
  top: -533.3333333333334px;
  left: -2483.3333333333335px;
  width: 665px;
`;